<template>
  <div ref="productCard" class="products-with-video__product-card" :data-productKey="product.code">
    <div class="products-with-video__product-image-wrap">
      <ProductPhoto
        @click="handleRedirect"
        :product-id="product.id"
        :link="product.link"
        :title="product.title"
        :image-url="product.image_url"
      />
    </div>
    <div class="products-with-video__product-info-wrap">
      <ProductTitle @click="handleRedirect" :link="product.link" :title="product.title" />
      <ProductPrice
        :old-price="+product.price.price_old"
        :price="+product.price.price_new"
        size="small"
        class="products-with-video__product-price"
      />
      <BuyBtn
        v-if="!!+product.is_available"
        :title-ru="product.title_anal"
        :title="product.title"
        :product-id="+product.id"
        :code="product.code.toString()"
        :price="+product.price.price_new"
        size="small"
      />
      <BuyBtn
        v-else-if="+product.is_novelty"
        :title-ru="product.title_anal"
        :title="product.title"
        :product-id="+product.id"
        :code="product.code.toString()"
        :price="+product.price.price_new"
        size="small"
        pre-order-btn
      />
      <WaitListBtn
        v-else
        :in-wait-list-status="!!+product.is_in_wait_list"
        :title-ru="product.title_anal"
        :product-id="+product.id"
        classes="wait-list__btn--small"
        is-small-card
      />
    </div>
  </div>
</template>

<script>
import CurrencyFormatter from '../../../filters/CurrencyFormatter'
import BuyBtn from '../../cart/BuyBtn'
import ProductPhoto from '../../product/ProductPhoto'
import ProductTitle from '../../product/ProductTitle'
import ProductPrice from '../../product/ProductPrice'
import WaitListBtn from '../../product/product-page/WaitListBtn'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'ProductsWithVideoProductCard',
  filters: {
    CurrencyFormatter
  },
  components: {
    BuyBtn,
    ProductPhoto,
    ProductTitle,
    ProductPrice,
    WaitListBtn
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    list: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    }
  },
  methods: {
    async handleRedirect (event) {
      const { e, link } = event
      e.preventDefault()

      await GoogleTagManagerService.productClickEvent({
        analyticsData: this.product.analytics_data.map(item => ({ ...item, position: this.position })),
        actionField: {
          'list': this.list || ''
        }
      })

      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        GoogleTagManagerService.productViewEvent({
          analyticsData: this.product.analytics_data.map(item => ({
            ...item,
            list: this.list || '',
            position: this.position
          }))
        })

        observer.unobserve(this.$refs.productCard)
      }
    })
    setTimeout(() => {
      observer.observe(this.$refs.productCard)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

.products-with-video__product-card
  display: flex
  flex-flow: row nowrap
  padding: 15px
  border: 1px solid $nd-border-color
  border-radius: 3px

.products-with-video__product-image-wrap
  position: relative
  width: 85px
  height: 85px
  object-fit: contain
  flex-shrink: 0

.products-with-video__product-image
  display: block
  width: 100%
  font-size: 8px

.products-with-video__product-info-wrap
  width: 100%
  display: flex
  flex-flow: column
  margin-left: 10px

.products-with-video__product-title
  -webkit-box-orient: vertical
  -webkit-line-clamp: 2
  color: $text-color
  font-weight: 400
  font-size: 14px
  margin-bottom: 5px

.products-with-video__product-price
  margin-bottom: 10px

.products-with-video__product-link
  display: block
  width: 100%
  max-width: max-content
  padding: 6px 22px 7px
  background-color: $main-color
  border-radius: 3px
  font-size: 12px
  color: $white-text-color

  &:hover
    background-color: $main-color--hover
</style>
